<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="productOtherCodeId"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <template #default="{status}">

        <t-input v-model="form.productOtherCodeId" hidden/>

        <b-col cols="12" class="mb-2">


          <b-row>

            <b-col cols="8">

              <t-input-product @focusout="focusByRef('input_code')" :status="status" :command="command" v-model="form.productId"
                               required/>

            </b-col>

            <b-col cols="4">

              <t-input v-model="form.code" ref="input_code" :add-error="error.code" label="Cód. para o cliente" required/>

            </b-col>

          </b-row>


          <b-row>

            <b-col cols="12" class="button-form-inline col-md-6 col-sm-12 mt-0">

              <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

              <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                {{ t('go-back') }}
              </b-link>

            </b-col>

          </b-row>

        </b-col>

      </template>

    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'CustomerProductOtherCode',
  data() {
    return {
      path: "product/item-other-code", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "customerId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "productOtherCodeId", keyDelete: "productOtherCodeId"},
        {key: "productCodeLabel", label: "Cód. interno do Produto", cols: "4"},
        {key: "code", label: "Cód. para o Cliente", cols: "4"},
      ],
      form: {
        customerId: this.foreignKey,
        productOtherCodeId: 0,
        productId: 0,
        code: "",
        typeRelation: 1,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        code: "",
      },
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      //Padrão neste caso deste tipo de relação, sendo fixo esta informação
      this.form.typeRelation = 1

    },

    mountedPrepare() {

      this.listParams.append("typeRelation",1)

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.productOtherCodeId)

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
